import * as z from 'zod';

export const loginAuthUserSchema = z.object({
  id: z.number(),
  name: z.string().nullable(),
  first_name: z.string(),
  last_name: z.string(),
  email: z.string().nullable(),
  username: z.string().nullable(),
  status: z.string(),
  user_type: z.string().nullable(),
  team_member_id: z.number().nullable(),
  microsoft_groups: z.string().nullable(),
  country_id: z.number().nullable(),
  created_at: z.string().nullable(),
  updated_at: z.string().nullable(),
  deleted_at: z.string().nullable(),
});

export const loginResponseSchema = z.object({
  message: z.string(),
  user: loginAuthUserSchema,
  token: z.string().min(1),
});

export type LoginAuthUserSchema = z.infer<typeof loginAuthUserSchema>;
export type LoginResponseSchema = z.infer<typeof loginResponseSchema>;
